import { styled } from '@linaria/react';
export const OverlayContent = /*#__PURE__*/styled('div')({
  name: "OverlayContent",
  class: "og0u57g",
  propsAsIs: false
});
export const MapContainer = /*#__PURE__*/styled('div')({
  name: "MapContainer",
  class: "mnhpqrf",
  propsAsIs: false
});
export const LeftInfoWrapper = /*#__PURE__*/styled('div')({
  name: "LeftInfoWrapper",
  class: "l1p223bn",
  propsAsIs: false
});

// Extend map under next sibling and push controls up to compensate
export const ExtendedMapContainer = /*#__PURE__*/styled('div')({
  name: "ExtendedMapContainer",
  class: "exctkbw",
  propsAsIs: false
});
export const MapOverlapBottomCTAPositioner = /*#__PURE__*/styled('div')({
  name: "MapOverlapBottomCTAPositioner",
  class: "m1fb6d9y",
  propsAsIs: false
});

require("./styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.tsx");